import { ReportData } from '../types/reportTypes';

// Parse currency string to number
const parseCurrency = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/[$,]/g, ''));
};

// Parse percentage string to number
const parsePercentage = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/%/g, '')) / 100;
};

// Calculate the sum of an array of numbers
const sum = (numbers: number[]): number => {
  return numbers.reduce((total, num) => total + num, 0);
};

// Calculate the individual job data from the Sales May CSV
const jobData = [
  {
    jobInfo: "E-398: Eric & Maria Metee",
    leadSource: "Google Organic Search",
    trade: "ROI Roofing",
    contractTotal: 8372.00,
    grossMarginPct: 0.4811,
    grossProfit: 4027.77,
    commissionPercentage: 4.00,
    salesCommission: 334.88,
    salesManagerFee: 83.72,
    companyOH: 1297.66,
    netProfit: 0
  },
  {
    jobInfo: "E-385: Rachel Small",
    leadSource: "Web to Lead Form",
    trade: "ROI Roofing",
    contractTotal: 42948.00,
    grossMarginPct: 0.5558,
    grossProfit: 23870.50,
    commissionPercentage: 7.00,
    salesCommission: 3006.36,
    salesManagerFee: 429.48,
    companyOH: 6656.94,
    netProfit: 0
  },
  {
    jobInfo: "E-404: Griffin Canfield",
    leadSource: "Google Organic Search",
    trade: "Entry Doors",
    contractTotal: 2619.00,
    grossMarginPct: 0.4105,
    grossProfit: 1075.10,
    commissionPercentage: 4.00,
    salesCommission: 104.76,
    salesManagerFee: 26.19,
    companyOH: 405.95,
    netProfit: 0
  },
  {
    jobInfo: "E-375: Paul Orejimi",
    leadSource: "Yelp",
    trade: "ROI Roofing",
    contractTotal: 8833.64,
    grossMarginPct: 0.4149,
    grossProfit: 3665.08,
    commissionPercentage: 4.00,
    salesCommission: 353.35,
    salesManagerFee: 88.34,
    companyOH: 1369.21,
    netProfit: 0
  },
  {
    jobInfo: "E-406: Adebayo & Grace Oyenubi",
    leadSource: "Web to Lead Form",
    trade: "ROI Roofing",
    contractTotal: 8672.00,
    grossMarginPct: 0.5559,
    grossProfit: 4820.76,
    commissionPercentage: 7.00,
    salesCommission: 607.04,
    salesManagerFee: 86.72,
    companyOH: 1344.16,
    netProfit: 0
  },
  {
    jobInfo: "E-377: Angelita Saunders",
    leadSource: "Web to Lead Form",
    trade: "ROI Roofing",
    contractTotal: 10200.00,
    grossMarginPct: 0.4270,
    grossProfit: 4355.40,
    commissionPercentage: 4.00,
    salesCommission: 408.00,
    salesManagerFee: 102.00,
    companyOH: 1581.00,
    netProfit: 0
  },
  {
    jobInfo: "E-376: Fran & James Hawkins",
    leadSource: "Yelp",
    trade: "ROI Siding",
    contractTotal: 17619.00,
    grossMarginPct: 0.5074,
    grossProfit: 8939.88,
    commissionPercentage: 7.00,
    salesCommission: 1233.33,
    salesManagerFee: 176.19,
    companyOH: 2730.95,
    netProfit: 0
  },
  {
    jobInfo: "E-371: Renee Morales",
    leadSource: "Yelp",
    trade: "ROI Roofing",
    contractTotal: 9611.05,
    grossMarginPct: 0.5781,
    grossProfit: 5556.15,
    commissionPercentage: 7.00,
    salesCommission: 672.77,
    salesManagerFee: 96.11,
    companyOH: 1489.71,
    netProfit: 0
  },
  {
    jobInfo: "E-402: Marcia Marsh",
    leadSource: "Thumbtack",
    trade: "Entry Doors",
    contractTotal: 5321.00,
    grossMarginPct: 0.5048,
    grossProfit: 2686.04,
    commissionPercentage: 7.00,
    salesCommission: 372.47,
    salesManagerFee: 53.21,
    companyOH: 824.76,
    netProfit: 0
  },
  {
    jobInfo: "E-390: Andrea & Christian Incognito",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 3272.00,
    grossMarginPct: 0.3461,
    grossProfit: 1132.44,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 32.72,
    companyOH: 507.16,
    netProfit: 0
  },
  {
    jobInfo: "E-389: Terry Scott",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors, ROI Siding",
    contractTotal: 23472.00,
    grossMarginPct: 0.4532,
    grossProfit: 10637.51,
    commissionPercentage: 4.00,
    salesCommission: 938.88,
    salesManagerFee: 234.72,
    companyOH: 3638.16,
    netProfit: 0
  },
  {
    jobInfo: "E-372: Lenore Pearman",
    leadSource: "Networx",
    trade: "Entry Doors",
    contractTotal: 4997.00,
    grossMarginPct: 0.4157,
    grossProfit: 2077.25,
    commissionPercentage: 4.00,
    salesCommission: 199.88,
    salesManagerFee: 49.97,
    companyOH: 774.54,
    netProfit: 0
  },
  {
    jobInfo: "E-384: Patricia & Tyrone Drummond",
    leadSource: "BBB",
    trade: "Entry Doors",
    contractTotal: 4900.00,
    grossMarginPct: 0.5233,
    grossProfit: 2564.17,
    commissionPercentage: 7.00,
    salesCommission: 343.00,
    salesManagerFee: 49.00,
    companyOH: 759.50,
    netProfit: 0
  },
  {
    jobInfo: "E-373: Diana & Cleo Sandoval",
    leadSource: "Thumbtack",
    trade: "Entry Doors",
    contractTotal: 2972.00,
    grossMarginPct: 0.5529,
    grossProfit: 1643.22,
    commissionPercentage: 7.00,
    salesCommission: 208.04,
    salesManagerFee: 29.72,
    companyOH: 460.66,
    netProfit: 0
  },
  {
    jobInfo: "E-386: Michael & Lea Salisbury",
    leadSource: "Web to Lead Form",
    trade: "ROI Roofing",
    contractTotal: 24014.00,
    grossMarginPct: 0.5599,
    grossProfit: 13445.44,
    commissionPercentage: 7.00,
    salesCommission: 1680.98,
    salesManagerFee: 240.14,
    companyOH: 3722.17,
    netProfit: 0
  },
  {
    jobInfo: "E-368: Claire & Michael Sterrett",
    leadSource: "Yelp",
    trade: "ROI Roofing",
    contractTotal: 26714.00,
    grossMarginPct: 0.5034,
    grossProfit: 13447.83,
    commissionPercentage: 7.00,
    salesCommission: 1869.98,
    salesManagerFee: 267.14,
    companyOH: 4140.67,
    netProfit: 0
  },
  {
    jobInfo: "E-369: James & Angela Billings-Kang",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 7596.00,
    grossMarginPct: 0.7859,
    grossProfit: 5969.70,
    commissionPercentage: 10.00,
    salesCommission: 759.60,
    salesManagerFee: 75.96,
    companyOH: 1177.38,
    netProfit: 0
  },
  {
    jobInfo: "E-401: Esmine McCaw",
    leadSource: "Homebuddy",
    trade: "Windows & Doors",
    contractTotal: 6540.00,
    grossMarginPct: 0.5373,
    grossProfit: 3513.94,
    commissionPercentage: 7.00,
    salesCommission: 457.80,
    salesManagerFee: 65.40,
    companyOH: 1013.70,
    netProfit: 0
  },
  {
    jobInfo: "E-362: Zahida & Hussain Noor",
    leadSource: "Thumbtack",
    trade: "ROI Roofing",
    contractTotal: 12472.00,
    grossMarginPct: 0.4253,
    grossProfit: 5304.34,
    commissionPercentage: 4.00,
    salesCommission: 498.88,
    salesManagerFee: 124.72,
    companyOH: 1933.16,
    netProfit: 0
  },
  {
    jobInfo: "E-357: Tiff Matthews",
    leadSource: "Thumbtack",
    trade: "ROI Siding, ROI Roofing",
    contractTotal: 27110.00,
    grossMarginPct: 0.6261,
    grossProfit: 16973.57,
    commissionPercentage: 10.00,
    salesCommission: 2711.00,
    salesManagerFee: 271.10,
    companyOH: 4202.05,
    netProfit: 0
  },
  {
    jobInfo: "E-359: Dominique Imeokparia",
    leadSource: "Yelp",
    trade: "Seamless Gutters",
    contractTotal: 1872.00,
    grossMarginPct: 0.4819,
    grossProfit: 902.12,
    commissionPercentage: 4.00,
    salesCommission: 74.88,
    salesManagerFee: 18.72,
    companyOH: 290.16,
    netProfit: 0
  },
  {
    jobInfo: "E-354: Byram & Adria Hunt",
    leadSource: "Angi",
    trade: "Attic Insulation",
    contractTotal: 4205.00,
    grossMarginPct: 0.7479,
    grossProfit: 3144.92,
    commissionPercentage: 10.00,
    salesCommission: 420.50,
    salesManagerFee: 42.05,
    companyOH: 651.78,
    netProfit: 0
  },
  {
    jobInfo: "E-400: Kenny Toro",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 12303.00,
    grossMarginPct: 0.4274,
    grossProfit: 5258.30,
    commissionPercentage: 4.00,
    salesCommission: 492.12,
    salesManagerFee: 123.03,
    companyOH: 1906.97,
    netProfit: 0
  },
  {
    jobInfo: "E-346: Christine & Steven Grant",
    leadSource: "Google Organic Search",
    trade: "ROI Roofing",
    contractTotal: 7719.00,
    grossMarginPct: 0.4785,
    grossProfit: 3693.54,
    commissionPercentage: 4.00,
    salesCommission: 308.76,
    salesManagerFee: 77.19,
    companyOH: 1196.45,
    netProfit: 0
  },
  {
    jobInfo: "E-374: Kenisha Kelley",
    leadSource: "Web to Lead Form",
    trade: "ROI Roofing",
    contractTotal: 11500.00,
    grossMarginPct: 0.3462,
    grossProfit: 3981.30,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 115.00,
    companyOH: 1782.50,
    netProfit: 0
  },
  {
    jobInfo: "E-348: Dan & Sharon Menck",
    leadSource: "Thumbtack",
    trade: "ROI Gutters",
    contractTotal: 3972.00,
    grossMarginPct: 0.6564,
    grossProfit: 2607.22,
    commissionPercentage: 10.00,
    salesCommission: 397.20,
    salesManagerFee: 39.72,
    companyOH: 615.66,
    netProfit: 0
  },
  {
    jobInfo: "Susan Lord",
    leadSource: "Homebuddy",
    trade: "Windows & Doors",
    contractTotal: 11620.00,
    grossMarginPct: 0.4000,
    grossProfit: 4648.00,
    commissionPercentage: 4.00,
    salesCommission: 464.80,
    salesManagerFee: 116.20,
    companyOH: 1801.10,
    netProfit: 0
  },
  {
    jobInfo: "Nick & Jason Heredia",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 22637.00,
    grossMarginPct: 0.4000,
    grossProfit: 9054.80,
    commissionPercentage: 4.00,
    salesCommission: 905.48,
    salesManagerFee: 226.37,
    companyOH: 3508.74,
    netProfit: 0
  },
  {
    jobInfo: "Richard & Unyoung Gleason",
    leadSource: "Homebuddy",
    trade: "Windows & Doors",
    contractTotal: 3490.00,
    grossMarginPct: 0.4000,
    grossProfit: 1396.00,
    commissionPercentage: 4.00,
    salesCommission: 139.60,
    salesManagerFee: 34.90,
    companyOH: 540.95,
    netProfit: 0
  },
  {
    jobInfo: "MRS Margaret EVELINE GUTH",
    leadSource: "Homebuddy",
    trade: "Windows & Doors",
    contractTotal: 9972.00,
    grossMarginPct: 0.4000,
    grossProfit: 3988.80,
    commissionPercentage: 4.00,
    salesCommission: 398.88,
    salesManagerFee: 99.72,
    companyOH: 1545.66,
    netProfit: 0
  },
  {
    jobInfo: "Brian & Brooke O'Connor",
    leadSource: "Yelp",
    trade: "ROI Siding",
    contractTotal: 5844.00,
    grossMarginPct: 0.4000,
    grossProfit: 2337.60,
    commissionPercentage: 4.00,
    salesCommission: 233.76,
    salesManagerFee: 58.44,
    companyOH: 905.82,
    netProfit: 0
  },
  {
    jobInfo: "Leonard Floyd",
    leadSource: "Homebuddy",
    trade: "Windows & Doors",
    contractTotal: 4713.00,
    grossMarginPct: 0.4000,
    grossProfit: 1885.20,
    commissionPercentage: 4.00,
    salesCommission: 188.52,
    salesManagerFee: 47.13,
    companyOH: 730.52,
    netProfit: 0
  },
  {
    jobInfo: "Wyletha & John Jackson",
    leadSource: "Facebook / Meta Ads",
    trade: "Windows & Doors, Solar Energy, ROI Roofing",
    contractTotal: 14794.00,
    grossMarginPct: 0.4000,
    grossProfit: 5917.60,
    commissionPercentage: 4.00,
    salesCommission: 591.76,
    salesManagerFee: 147.94,
    companyOH: 2293.07,
    netProfit: 0
  },
  {
    jobInfo: "E-396: Cathy Hwang",
    leadSource: "Google Organic Search",
    trade: "ROI Gutters, ROI Roofing",
    contractTotal: 18672.00,
    grossMarginPct: 0.5685,
    grossProfit: 10615.03,
    commissionPercentage: 7.00,
    salesCommission: 1307.04,
    salesManagerFee: 186.72,
    companyOH: 2894.16,
    netProfit: 0
  },
  {
    jobInfo: "E-378: Rosa Mayberry",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 13023.00,
    grossMarginPct: 0.4642,
    grossProfit: 6045.28,
    commissionPercentage: 4.00,
    salesCommission: 520.92,
    salesManagerFee: 130.23,
    companyOH: 2018.57,
    netProfit: 0
  },
  {
    jobInfo: "E-360: Jimmie & Karlene Griffea",
    leadSource: "Networx",
    trade: "Attic Insulation",
    contractTotal: 4221.00,
    grossMarginPct: 0.6948,
    grossProfit: 2932.75,
    commissionPercentage: 10.00,
    salesCommission: 422.10,
    salesManagerFee: 42.21,
    companyOH: 654.26,
    netProfit: 0
  },
  {
    jobInfo: "Eugene & Darnita Akers",
    leadSource: "Homebuddy",
    trade: "ROI Roofing",
    contractTotal: 12872.00,
    grossMarginPct: 0.4000,
    grossProfit: 5148.80,
    commissionPercentage: 4.00,
    salesCommission: 514.88,
    salesManagerFee: 128.72,
    companyOH: 1995.16,
    netProfit: 0
  }
];

// Apply business logic to calculate net profit for standard reports
jobData.forEach(job => {
  // For standard reports: Net Profit = Gross Profit - (Sales Commission + Sales Manager Fee + Company OH)
  job.netProfit = job.grossProfit - (job.salesCommission + job.salesManagerFee + job.companyOH);
});

// Calculate totals
const totalContractValue = sum(jobData.map(job => job.contractTotal));
const totalGrossProfit = sum(jobData.map(job => job.grossProfit));
const totalSalesCommissions = sum(jobData.map(job => job.salesCommission));
const totalManagerFees = sum(jobData.map(job => job.salesManagerFee));
const totalCompanyOH = sum(jobData.map(job => job.companyOH));
const totalNetProfitBeforeAdSpend = sum(jobData.map(job => job.netProfit));

// Ad spend data from CSV
const adSpendData = [
  { source: "Google Organic Search", spend: 3500.00 },
  { source: "Porch", spend: 284.80 },
  { source: "Guild Quality", spend: 0.00 },
  { source: "Networx", spend: 3026.00 },
  { source: "Contractor Appointment", spend: 0.00 },
  { source: "HomeBuddy", spend: 8145.00 },
  { source: "Thumbtack", spend: 10500.00 },
  { source: "Web to Lead Form", spend: 11100.00 },
  { source: "Yelp", spend: 3924.82 },
  { source: "Google AdWords", spend: 369.17 },
  { source: "Google LSA", spend: 310.78 },
  { source: "BBB", spend: 300.00 },
  { source: "Lead2Performance", spend: 0.00 },
  { source: "Spring Connect", spend: 0.00 },
  { source: "Facebook / Meta Ads", spend: 6052.60 },
  { source: "Angi", spend: 2530.00 }
];

const totalAdSpend = sum(adSpendData.map(item => item.spend));

// Calculate final net profit after subtracting ad spend
const totalNetProfit = totalNetProfitBeforeAdSpend - totalAdSpend;

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade || 'Other';
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

// Export the final report data object
export const mayData: ReportData = {
  kpis: {
    // Total ad spend from CSV
    adSpend: totalAdSpend,
    
    // Sum of all contract totals
    totalSales: totalContractValue,
    
    // Sum of all gross profits
    grossProfit: totalGrossProfit,
    
    // Sum of all sales commissions
    salesCommissions: totalSalesCommissions,
    
    // Sum of all manager fees
    managerFees: totalManagerFees,
    
    // Company overhead 
    companyOH: totalCompanyOH,
    
    // Net profit based on standard calculation formula
    netProfit: totalNetProfit,
    
    // Net profit as percentage of total sales
    netProfitPercent: totalNetProfit / totalContractValue,
    
    // Gross profit as percentage of total sales
    grossProfitPercent: totalGrossProfit / totalContractValue
  },
  
  // Ad spend by source from CSV
  adSpendBySource: adSpendData,
  
  // Sales by lead source - aggregated above
  salesBySource: salesBySource,
  
  // Sales by trade - aggregated above
  salesByTrade: salesByTrade,
  
  // Individual job data
  jobData: jobData,
  
  // Report period information
  period: {
    month: 5, // May (1-12)
    year: 2025
  }
};